import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../../common/Card/Card";
import Table from "../../../../common/Table/Table";
import { ROUTES } from "../../../../../routes";
import styles from "./DespositTransaction.module.scss";
import { STATUS_CODE } from "../../../../../utils/constants";
import {
  getUserCoinListAction,
  getWithdrawHistoryAction,
  getDepositHistoryAction,
} from "../../../../../features/user/userSlice";
import {
  formatPrice,
  formatDepositPrice,
  toFix,
} from "../../../../../utils/utils";
import { useNavigate } from "react-router-dom";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Tooltip from "../../../../common/Tooltip/Tooltip";

const DespositTransaction = () => {
  const [search, setSearch] = useState("");
  const storeCoinId = useSelector((state) => state.users.selectedCoinId);
  const [coinOptions, setCoinOptions] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [selectedCoin, setSelectedCoin] = useState({});
  const [selectedNetwork, setSelectedNetwork] = useState({});
  const [networkOptions, setNetworkOptions] = useState([]);
  const [coinLists, setCoinList] = useState([]);
  const [currentTab, setCurrentTab] = useState("Deposit");
  const [withdrawData, setWithdrawData] = useState([]);
  const [depositData, setDepositData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const navigate = useNavigate();

  const fetchCoinOptions = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        setCoinList(newData);
        newData?.forEach((coin) => {
          array.push({
            value: coin.id,
            label: coin.coin_symbol,
            networkdetails: coin.networkDetail,
            coinImage: coin.image_path,
          });
        });
        setCoinOptions(array);
        console.log("array", array);
        if (array.length > 0) {
          const defaultCoin = array[0];
          setSelectedCoin(defaultCoin);
          // withdrawHistory();
          // depositHistory();
          const defaultNetwork = defaultCoin.networkdetails[0];
          setSelectedNetwork({
            value: defaultNetwork.id,
            label: defaultNetwork.parent_coin_name,
          });
          setNetworkOptions(
            defaultCoin.networkdetails.map((network) => ({
              value: network.id,
              label: network.parent_coin_name,
            }))
          );
        }
      }
    } catch (error) {
      setError("Error fetching coin options.");
      console.error("Error fetching coin options:", error);
    } finally {
      setLoading(false);
    }
  };

  const withdrawHistory = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getWithdrawHistoryAction({
          page: page,
          limit: 5,
          coinId: storeCoinId,
        })
      );
      if (response.data.status === STATUS_CODE.successful) {
        setWithdrawData(response.data.data.data.withdrawlist);
      }
    } catch (error) {
      setError("Error fetching withdraw history.");
      console.error("Error fetching withdraw history:", error);
    } finally {
      setLoading(false);
    }
  };

  const depositHistory = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getDepositHistoryAction({
          page: page,
          limit: 5,
          coinId: storeCoinId,
        })
      );
      if (response.data.status === STATUS_CODE.successful) {
        setDepositData(response.data.data.data.depositlist);
      }
    } catch (error) {
      setError("Error fetching deposit history.");
      console.error("Error fetching deposit history:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCoinOptions();
  // }, []);

  // useEffect(() => {
  //   navigate(ROUTES.DESPOSIT); // Ensure it navigates to the Deposit route on mount
  //   fetchCoinOptions();
  // }, []);

  // useEffect(() => {
  //   if (currentTab === "Withdraw") {
  //     withdrawHistory();
  //   } else if (currentTab === "Deposit") {
  //     depositHistory();
  //   }
  // }, [currentTab, storeCoinId]);

  useEffect(() => {
    navigate(ROUTES.DESPOSIT);
    fetchCoinOptions();
  }, []);

  useEffect(() => {
    if (storeCoinId && currentTab === "Deposit") {
      depositHistory();
    } else if (storeCoinId && currentTab === "Withdraw") {
      withdrawHistory();
    } else {
      fetchCoinOptions();
    }
  }, [currentTab, storeCoinId]);

  const filterCoins = () => {
    if (currentTab === "Deposit") {
      return depositData;
    } else if (currentTab === "Withdraw") {
      return withdrawData;
    } else {
      return coinLists;
    }
  };

  const getFieldsByTab = () => {
    if (currentTab === "Deposit") {
      return [
        { label: "Coin Name", key: "coin_name" },
        { label: "Transaction ID", key: "transaction_id" },
        { label: "Amount", key: "amount" },
        { label: "Status", key: "status" },
        { label: "Transaction Type", key: "transaction_type" },
      ];
    } else if (currentTab === "Withdraw") {
      return [
        { label: "Coin Name", key: "coin_name" },
        { label: "Transaction ID", key: "transaction_id" },
        { label: "Amount", key: "amount" },
        { label: "Status", key: "status" },
        { label: "Transaction Type", key: "transaction_type" },
      ];
    } else {
      return [
        { label: "Coin Name", key: "coin_name" },
        { label: "Price", key: "coinPrice" },
        { label: "My Balance", key: "balance" },
        { label: "In Order", key: "locked_balance" },
      ];
    }
  };

  const formatTransactionId = (id) => {
    if (!id) return "-";
    if (id.length <= 10) return id;
    return `${id.slice(0, 5)}...${id.slice(-5)}`;
  };

  const formatCoin = (id) => {
    const defaultCoin = coinOptions?.find((coin) => coin.label === "BTC");
    if (!id)
      return defaultCoin ? (
        <div className={styles.coin}>
          <img
            src={defaultCoin.coinImage}
            alt={defaultCoin.label}
            className={styles.coinImage}
          />
          {defaultCoin.label}
        </div>
      ) : (
        "BTC"
      );

    const coin = coinOptions?.find((coin) => coin.value === id);
    return coin ? (
      <div className={styles.coin}>
        <img
          src={coin.coinImage}
          alt={coin.label}
          className={styles.coinImage}
        />
        {coin.label}
      </div>
    ) : defaultCoin ? (
      <div className={styles.coin}>
        <img
          src={defaultCoin.coinImage}
          alt={defaultCoin.label}
          className={styles.coinImage}
        />
        {defaultCoin.label}
      </div>
    ) : (
      "Unknown Coin"
    );
  };

  const formatTransactionType = (type) => {
    switch (type) {
      case 1:
        return "Internal";
      case 2:
        return "External";
      default:
        return type;
    }
  };

  const formatDepositStatus = (status) => {
    switch (status) {
      case 1:
      case 6:
        return "Completed";
      case 0:
        return "Pending";
      case 2:
        return "Completed";
      case 3:
        return "Completed";
      case 4:
        return "Completed";
      case 5:
        return "Error while Moved to Central Wallet";
      default:
        return "Unknown Status";
    }
  };

  const formatStatus = (status) => {
    if (currentTab === "Deposit") {
      return formatDepositStatus(status);
    }
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "In Progress";
      case 3:
        return "Rejected";
      case 5:
        return "Cancelled";
      case 6:
        return "Confirmed";
      default:
        return "In Progress";
    }
  };

  return (
    <>
      <div className={styles.transaction}>
        <div className={styles.transaction_in}>
          <Row>
            <Col lg={8}>
              <div className={styles.transaction_left}>
                <Card
                  className={styles.cardTable}
                  bodyClassName={styles.body}
                  title={<></>}
                  headerContent={
                    <>
                      <div className={styles.tabs}>
                        <NavLink
                          onClick={() => setCurrentTab("Deposit")}
                          to={ROUTES.DESPOSIT}
                          className={
                            currentTab === "Deposit" ? styles.active : ""
                          }
                        >
                          Deposit
                        </NavLink>
                        <NavLink
                          onClick={() => setCurrentTab("Withdraw")}
                          to={ROUTES.WIDTHROW}
                          className={
                            currentTab === "Withdraw" ? styles.active : ""
                          }
                        >
                          Withdraw
                        </NavLink>
                      </div>
                    </>
                  }
                >
                  <Outlet />
                </Card>
              </div>
            </Col>
          </Row>
        </div>
        <div className="transaction_content mt-5">
          <Card
            className={styles.transactions}
            bodyClassName={styles.body}
            title={<>Transaction</>}
            headerContent={
              <>
                <div className={styles.tabs}>
                  <NavLink
                    onClick={() => setCurrentTab("All Coins")}
                    to={ROUTES.ALL_COINS}
                    className={currentTab === "All Coins" ? styles.active : ""}
                  >
                    All Coins
                  </NavLink>
                  <NavLink
                    onClick={() => setCurrentTab("Deposit")}
                    to={ROUTES.DESPOSIT}
                    className={currentTab === "Deposit" ? styles.active : ""}
                  >
                    Deposit
                  </NavLink>
                  <NavLink
                    onClick={() => setCurrentTab("Withdraw")}
                    to={ROUTES.WIDTHROW}
                    className={currentTab === "Withdraw" ? styles.active : ""}
                  >
                    Withdraw
                  </NavLink>
                </div>
              </>
            }
          >
            <Table
              fields={getFieldsByTab()}
              className={"table"}
              loading={loading}
            >
              {currentTab === "Deposit" &&
                depositData?.map((item) => (
                  <tr key={item.transaction_id}>
                    <td>{formatCoin(item?.coin_id)}</td>
                    <td>
                      <Tooltip
                        icon={
                          <span>
                            {formatTransactionId(item?.transaction_id) || "NA"}
                          </span>
                        }
                        content={
                          <>
                            <CopyBtn text={item?.transaction_id} />{" "}
                            {item?.transaction_id}
                          </>
                        }
                      />
                    </td>
                    <td>{formatDepositPrice(item?.amount)}</td>
                    {/* <td>
                      {formatPrice(item?.amount).replace(
                        /(\.\d{2})$/,
                        (match) => match + "000"
                      )}
                    </td> */}

                    <td>{formatStatus(item?.status)}</td>
                    <td>{formatTransactionType(item?.transaction_type)}</td>
                  </tr>
                ))}
              {currentTab === "Withdraw" &&
                withdrawData?.map((item) => (
                  <tr key={item.transaction_id}>
                    <td>{formatCoin(item?.coin_id)}</td>
                    <td>
                      <Tooltip
                        icon={
                          <span>
                            {formatTransactionId(item?.transaction_id) || "NA"}
                          </span>
                        }
                        content={
                          <>
                            <CopyBtn text={item?.transaction_id} />{" "}
                            {item?.transaction_id}
                          </>
                        }
                      />
                    </td>
                    <td>{formatDepositPrice(item?.amount)}</td>
                    {/* <td>
                      {formatPrice(item?.amount).replace(
                        /(\.\d{2})$/,
                        (match) => match + "000"
                      )}
                    </td> */}

                    <td>{formatStatus(item?.status)}</td>
                    <td>{formatTransactionType(item?.transaction_type)}</td>
                  </tr>
                ))}
              {currentTab === "All Coins" &&
                coinLists?.map((item) => (
                  <tr key={item.id}>
                    <td>{formatCoin(item?.id)}</td>
                    <td>${formatPrice(item?.coinPrice)}</td>
                    <td>
                      {item?.balance != 0
                        ? toFix(item?.balance, decimalLimit[item?.coin_symbol])
                        : 0}
                    </td>
                    <td>
                      {item?.locked_balance != 0
                        ? toFix(
                            item?.locked_balance,
                            decimalLimit[item?.coin_symbol]
                          )
                        : 0}
                    </td>
                  </tr>
                ))}
            </Table>
          </Card>
        </div>
      </div>
    </>
  );
};

export default DespositTransaction;
